<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="gridOptions.columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%;min-height: 500px;padding-left: 16px;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers" style="flex:none">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button no="back" type="primary" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--编辑-->
                  <el-button no="Edit" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
                  <!--打印-->
                  <el-button no="print" :disabled="isEditing" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
                </div>
                <div v-show="isNew || action==='edit'" class="new" style="border-left:none;padding-left:0">
                  <el-button no="save" type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="cancel" type="success" @click="cancelEdit(onRefresh)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="onPrintHandler" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
                </div>
              </cargo-button-group-slider>
            </div>
          </div>
          <el-tabs
            v-model="activeTabName"
            type="card"
            style="width:100%"
          >
            <el-tab-pane :label="$t('Message.Main')" :lazy="true" name="baseInfo" class="warehousingDetail">
              <warehousing-detail ref="baseInfo" :warehouse-in-uuid="currentRow.uuid" :lob="lob" :action="action" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import locationImg from '@/assets/location24.png'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { getLoading } from '@/utils/utilBaseElement'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import warehousingDetail from './warehousingDetail'
import { saveFunc } from '@/api/warehouseIn/warehouseIn'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import { SizeUtils } from '@/class/cargo/model/utils/SizeUtils'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
export default {
  name: 'WarehousingWorkspace',
  components: {
    warehousingDetail,
    DropUploader,
    cargoAdvanceSelect,
    cargoLeftRightResize,
    cargoUserSelect,
    CargoButtonGroupSlider
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    lob: { type: String, required: true }
  },
  data() {
    return {
      locationImg,
      URL,
      selectTypeNames: TYPE_NAMES,
      SystemConstants,
      action: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        columnDefs: [
          { headerName: this.$t('Warehouse.WarehouseNo'), field: 'warehouseNo', minWidth: 160, colId: 'warehouseNo' }
        ],
        onRowClicked: this.changeWareHouseIn
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      isRefresh: true,
      activeTabName: 'baseInfo'
    }
  },
  computed: {
    user() {
      return this.$store.getters.userId
    },
    isNew() {
      return this.action === 'add'
    },
    isEditing() {
      return this.action !== 'look'
    }
  },
  async created() {
    this.loadConfigData()
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.activeTabName = 'baseInfo'
      this.selectedRow = selectedRow
      this.action = action
      this.rowData = rowData
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.gridApi.clearFocusedCell()
        if (!selectedRow.uuid) {
          this.currentRow = selectedRow
          await this.$refs['baseInfo'].onShow(this.action, selectedRow)
        } else {
          await this.onRowClicked({ data: selectedRow })
        }
      })
    },
    // 加载配置项
    loadConfigData() {
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid
        const rowKey = row.uuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          break
        }
      }
    },
    async changeWareHouseIn(event) {
      const result = event.data
      if (result) {
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        await this.onRowClicked({ data: result })
      }
    },
    // 行点击
    async onRowClicked(event) {
      if (!event.data) {
        return
      }
      this.currentRow = null
      const warehouse = event.data
      this.currentRow = warehouse
      this.setGridSelect(this.currentRow)
      this.transferTargetRow(this.action, warehouse.uuid)
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // 编辑
    editHandler(row) {
      if (!row) {
        row = this.currentRow
      }
      if (row.instoreFrom) {
        this.$message.info(this.$t('Warehouse.ExternallyImportedDataCannotEdit'))
        return
      }
      this.onShow('edit', this.rowData, row)
    },
    // 打印
    onPrintHandler() {
      const rows = []
      rows.push(this.currentRow)
      this.$emit('print', rows)
    },
    async save() {
      await sleep(200)
      const getSubmitData = this.$refs['baseInfo'].getSubmitData()
      const { warehouseNo, warehouse, warehouseInDetailList, sealWeight, sealCargo, warehouseInDate } = { ...getSubmitData.form }
      if (this.lob === 'AE' && !warehouseInDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterActualWarehousingTime'))
        return false
      }
      if (!warehouseNo) {
        this.$message.warning(this.$t('Message.PleaseEnterTheWarehousingNumber'))
        return false
      }
      if (!warehouse) {
        this.$message.warning(this.$t('Message.PleaseEnterTheWarehouseName'))
        return false
      }
      if (sealCargo && sealWeight === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectTheClosingWeight'))
        return false
      }
      if (warehouseInDetailList && warehouseInDetailList.length > 0) {
        for (const w of warehouseInDetailList) {
          if (!SizeUtils.validateSize(w.dimension)) {
            this.$message.warning(this.$t('Message.PleaseLengthWidthPieces'))
            return false
          }
          if (w.quantity === 0) {
            this.$message.warning(this.$t('Message.PleaseTheNumberOfPieces'))
            return false
          }
        }
      }
      this.loading = getLoading()
      const params = { ...getSubmitData.form }
      params.check = !params.uuid
      saveFunc(params).then(resp => {
        if (resp && resp.data === FbaJobConstants.WAREHOUSE_OP_STORED) {
          this.$message.warning(this.$t('SeaExport.StoredTipFour'))
          return
        }
        if (resp && resp.data === 'WAREHOUSE_NO EXISTS') {
          this.$confirm(this.$t('Message.WarehouseNumberAlreadyExistsContinue'), this.$t('common.tips.confirm'), {
            confirmButtonText: this.$t('common.btn.yes'),
            cancelButtonText: this.$t('common.btn.no'),
            closeOnClickModal: false,
            type: 'info'
          }).then(() => {
            params.check = false
            saveFunc(params).then(resp => {
              this.saveHandler(getSubmitData, resp)
            }).finally(() => this.loading.close())
          }).finally((e) => {
            this.loading.close()
          })
        } else {
          this.saveHandler(getSubmitData, resp)
        }
      }).finally(() => this.loading.close())
    },
    saveHandler(getSubmitData, resp) {
      this.loading.close()
      this.$message.success(this.$t('Message.SavedSuccessfully'))
      this.currentRow = getSubmitData.form
      this.currentRow.dateCreated = new Date()
      this.currentRow.uuid = resp.data
      const is = this.rowData.find(p => p.uuid === resp.data)
      // 新增一条数据
      if (!is) {
        this.rowData.push(this.currentRow)
      } else {
        // 更新原数据
        const list = []
        for (let p of this.rowData) {
          if (p.uuid === resp.data) {
            p = this.currentRow
          }
          list.push(p)
        }
        this.rowData = list
      }
      this.$emit('refresh', this.currentRow)
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (this.action === 'add' && this.rowData.length === 0) {
          this.goBack()
        } else if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    goBack() {
      this.activeTabName = 'baseInfo'
      this.action = ''
      this.$emit('back', this.selectedRow)
    },
    transferTargetRow(action, warehouseKey) {
      if (!this.rowData) {
        return
      }
      const selectedRow = this.rowData.find(p => p.uuid === warehouseKey)
      if (selectedRow) {
        this.$refs['baseInfo'].onShow(this.action)
      }
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 刷新
    onRefresh() {
      this.$emit('refresh', this.currentRow)
    }
  }
}
</script>

<style lang="scss">
.booking-details {
  .el-tabs__nav-prev,.el-tabs__nav-next{
    line-height: 29px;
  }
  .el-tabs__content{
    overflow: auto
  }
  .warehousingDetail{
    height: 100%;
  }
}
</style>
